/** Extra chat fillers hidden only while reading the word list; stored baseline counts remain unchanged. */
export const STATISTICS_CHAT_FILLER_WORDS = [
  "danke", "genau", "geil", "gg", "haha", "hallo", "hehe", "kek", "krass", "lol",
  "lul", "moin", "nein", "nice", "oh", "ok", "okay", "w", "xd", "f",
] as const;
